import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Flex, Form, Image, Row, Select, Space } from "antd";
import { useEffect, useRef } from "react";
import { ConfiguracaoImpostoAdicionalModel } from "../../../../models/configuracaoImpostoAdicional/configuracaoImpostoAdicionalModel";
import { atualizarConfiguracaoImpostoAdicional, cadastrarConfiguracaoImpostoAdicional } from "../../../../services/configuracaoImpostoAdicionalService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { NumericFormat } from "react-number-format";
import { setModalCadastrarConfiguracaoImpostoAdicional } from "../../../../redux/slices/configuracaoImpostoAdicional/configuracaoImpostoAdicionalSlice";
import dayjs from "dayjs";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";

dayjs.locale("pt-br");

const NovoConfiguracaoImpostoAdicional = () => {
  //estados globais
  const configuracaoImpostoAdicionalState = useAppSelector((state) => state.configuracaoImpostoAdicional);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<ConfiguracaoImpostoAdicionalModel>();
  const editar = Object.values(configuracaoImpostoAdicionalState.entity).length !== 0;
  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      const { id, idEmpresa, mesAno, quantidadeSorteio } = configuracaoImpostoAdicionalState.entity;
      form.setFieldsValue({
        idEmpresa,
        mesAno: mesAno ? dayjs(mesAno) : new Date(), // Certifique-se de que 'mesAno' seja uma data válida ou null
        quantidadeSorteio,
      });
    } else {
      form.setFieldsValue({
        idEmpresa: configuracaoImpostoAdicionalState.busca.idEmpresa ?? undefined,
      });
    }
  }, [configuracaoImpostoAdicionalState.entity]);

  const submit = (values: ConfiguracaoImpostoAdicionalModel) => {
    if (editar) {
      dispatch(atualizarConfiguracaoImpostoAdicional({ value: { ...values, id: configuracaoImpostoAdicionalState.entity.id }, busca: configuracaoImpostoAdicionalState.busca }));
    } else {
      dispatch(cadastrarConfiguracaoImpostoAdicional({ value: values, busca: configuracaoImpostoAdicionalState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarConfiguracaoImpostoAdicional(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Empresa"
            name="idEmpresa"
            rules={[
              {
                required: true,
                message: "Selecione uma empresa",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="labelSearch"
              placeholder="Selecione uma empresa"
              loading={empresaState.loading}
              style={{ width: "100%" }}
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={6} style={{ flex: "unset" }}>
          <Form.Item
            label="Mes/Ano"
            name="mesAno"
            rules={[
              {
                required: true,
                message: "Selecione o mês e ano",
              },
            ]}
          >
            <DatePicker format={"MM/YYYY"} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Quantidade Sorteio"
            name="quantidadeSorteio"
            rules={[
              {
                required: true,
                message: "Digite a quantidade",
              },
            ]}
          >
            <NumericFormat className="ant-input noBoderColor number-input" thousandSeparator="." decimalSeparator="," decimalScale={0} fixedDecimalScale={true} />
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            {editar ? "ATUALIZAR" : "SALVAR"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default NovoConfiguracaoImpostoAdicional;
